<div class="page">
  <div class="content">
    <div class="detail">
      <div class="square"></div>
      <div class="triangle-up"></div>
      <div class="triangle-down"></div>
      <div class="circle-symbole"></div>
      <div class="maininfo">
        <div class="item image-box">
          <img src="../../../../assets/images/icons/LogoW.png" loading="lazy" class="app-logo" alt="sepidz company dark logo" />
        </div>
        <div class="versioninfo">
          <div class="title">
            {{ "General.Sepidz" | translate }}
          </div>
          <div class="light">{{ "General.Version" | translate }} {{ currentInformation?.ProductVersion }}</div>
          <div class="light">
            {{ today }}
          </div>
        </div>
        <div class="item footer-box" (click)="showInfo()">
          <span> {{ "General.CustomerCode" | translate }}</span>
          <strong>{{ currentInformation?.LockNumber }} </strong>
        </div>
      </div>
    </div>
    <div class="users">
      <div>
        <img class="sepidz-icon" src="../../../../assets/images/icons/icon384.png" />
      </div>
      <div class="header-title">راهکارهای نرم افزار رستورانی</div>
      <div class="virtualbox">
        <div class="virtual">
          <a href="https://www.instagram.com/sepidzpos/" target="_blank"><i class="icon-instagram1"></i></a>
        </div>
        <div class="virtual">
          <a href="https://sepidz.com/" target="_blank"><i class="icon-globe"></i></a>
        </div>
        <div class="virtual">
          <i class="icon-call-o"></i>
        </div>
      </div>
      <form [formGroup]="group" (ngSubmit)="login()" aria-labelledby="title" class="frm-login">
        <div class="loginbox">
          <div class="item">
            <ssg-select
              name="BranchId"
              defaultHeight="50"
              autofocus
              autocomplete="off"
              [group]="group"
              textFieldName="Title"
              apiName="Branch/ReadBranchLookUp"
              [required]="true"
              valueFieldName="Id"
              (valueChange)="onBranchChanged()"
              (valueClear)="onBranchClear()"
              [label]="'General.Branch' | translate"
              (CompleteData)="completeBranchData($event)"></ssg-select>
          </div>
          <div class="item">
            <ssg-select
              name="Id"
              defaultHeight="50"
              [group]="group"
              textFieldName="DisplayName"
              [required]="true"
              valueFieldName="Id"
              [dataList]="users"
              (valueChange)="onDisplayNameChanges()"
              [label]="'General.User' | translate"></ssg-select>
          </div>
          <div class="item custom">
            <ssg-input
              [group]="group"
              defaultHeight="50"
              [required]="true"
              name="Password"
              [textType]="'password'"
              autocomplete="off"
              [minLength]="3"
              [label]="'General.Password' | translate">
            </ssg-input>
          </div>
        </div>
        <div class="item custom" *ngIf="isSepidzUser">
          <ssg-input
            [icon]="showNumber ? 'icon-visibility_off-o' : 'icon-visibility-o'"
            [group]="group"
            defaultHeight="50"
            [required]="true"
            name="PhoneNumber"
            [textType]="showNumber ? 'text' : 'password'"
            autocomplete="off"
            [minLength]="6"
            (iconClick)="onShowNumber()"
            label="شماره موبایل">
          </ssg-input>
        </div>
        <div class="footer">
          <div class="rememberbox"></div>
          <div class="btnbox">
            <ssg-button
              *ngIf="isSepidzUser"
              [disabled]="isLoading || !group?.controls['PhoneNumber']?.value"
              class="login-btn"
              icon="icon-login-o"
              label="ارسال کد"
              buttontype="button"
              (click)="onSendCode()"
              appearance="flat">
            </ssg-button>
            <ssg-button
              [disabled]="!group?.valid || isLoading"
              class="login-btn"
              icon="icon-login-o"
              [label]="'General.SubmitLogin' | translate"
              buttontype="submit"
              appearance="flat"></ssg-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
